import { configureStore } from '@reduxjs/toolkit';
import authReducer from "./authSlice";
import profileReducer from "./profileSlice";
import { apiSlice } from '../api/apiSlice';
import commonReducer from "./commonSlice";
import { rtkQueryErrorLogger } from '../api/rtkQueryErrorLogger';

export const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        auth: authReducer,
        profile: profileReducer,
        common: commonReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware).concat(rtkQueryErrorLogger),
    devTools: process.env.NODE_ENV !== 'production',
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
